import { Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {load} from '@cashfreepayments/cashfree-js';
import { MatDialog } from '@angular/material/dialog';
import { PaymentStatusModalComponent } from '../sharedComponents/payment-status-modal/payment-status-modal.component';
import { WalletinfoService } from 'src/app/_service/walletinfo.service';
import { URLS } from 'src/app/constants/URLS';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';
import { IosBridgeService } from 'src/app/_service/ios-bridge.service';

@Component({
  selector: 'app-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.css']
})
export class PaymentsComponent implements OnInit, OnDestroy {

  amount = 0;
  orderId = '';
  userEmail = '';
  selectedPlan:any;
  userId:string = '';
  cashfreeLoaded = false;
  cashfree:any;
  contact:string = '';
  userName:string = '';
  wallet:any;
  channelUrl:string = URLS.channelUrl;
  imgUrl:string = URLS.imgUrl;
  url:string = URLS.BASE_URL;
  paymentType:string;
  paymentMode:string = 'toqqerpayments';
  isLoading:boolean = false;
  redirectUrl:string = '';
  private nativeIAPHandler!: (event: any) => void;
  private purchaseCancelledHandler!: () => void;
  private isPaymentHandled = false;

  constructor(
    private route: ActivatedRoute,
    private walletService:WalletinfoService,
    private toastrService: CustomControlsService,
    private router: Router,
    private dialog: MatDialog,
    private bridgeService: IosBridgeService,
    private ngZone: NgZone
  ) {
    // window.addEventListener('nativeIAPEvent', (event: any) => {
    //   const transactionId = event?.detail;
    //   if (!transactionId) return;
    //   const url = new URL(window.location.href);
    //   console.log("received status", event);
    //   url.searchParams.set("transactionId", event?.detail?.appAccountToken);
    //   window.history.replaceState({}, "", url.toString());
    //   console.log("Updated URL:", url.toString());
    // });
    // this.userName = localStorage.getItem('screenName');
    // this.contact = localStorage.getItem('contact');
    // this.route.queryParams.subscribe(params => {
    //   this.paymentType = params['type'];
      
    //   if (this.paymentType === 'channel') {
    //     this.selectedPlan = {
    //       channelId: params['channelId'],
    //       channel: decodeURIComponent(params['channel']),
    //       subscriptionId: params['subId'],
    //       durationId: params['durId'],
    //       cost: params['planAmount'],
    //       durationName: decodeURIComponent(params['durationName']),
    //       vidLibId: params['vidLibId'],
    //       contentType: params['contentType']
    //     };
    //   } else if (this.paymentType === 'ppv') {
    //     this.selectedPlan = {
    //       vidLibId: params['vidLibId'],
    //       movie: decodeURIComponent(params['movie']),
    //       durationId: params['durId'],
    //       cost: params['planAmount'],
    //       durationName: decodeURIComponent(params['durationName']),
    //     };
    //   }
    //   if(params['transactionId']){
    //     const data = {
    //       'status': 'success',
    //       'subType': this.paymentType,
    //       'vidLibId': this.selectedPlan?.vidLibId,
    //       'message': 'Your Subscription is in progess! please wait for sometime.',
    //       'transactionId': params['transactionId'],
    //       'dateOfSubscription': new Date(),
    //       'dateOfExpiry': new Date(),
    //       'amount': this.selectedPlan?.cost,
    //       'detailsRoute': 'channel',
    //       channelId: params['channelId'],
    //     }
    //     this.showPaymentStatus(data);
    //   }
    //   console.log(this.selectedPlan)
    // });
  }
  ngOnInit() {
    this.userId = localStorage.getItem('userId');
    this.nativeIAPHandler = (event: any) => {
      const detail = event?.detail;
      console.log('received nativeIAPEvent', detail);
      if (detail?.event === 'purchaseCancelled') {
        this.ngZone.run(() => {
          this.isLoading = false;
        });
        return;
      }
      const transactionId = detail?.appAccountToken;
      if (!transactionId) return;
      this.ngZone.run(() => {
        this.router.navigate([], {
          queryParams: { transactionId },
          queryParamsHandling: 'merge',
          replaceUrl: true
        });
      });
    };
    window.addEventListener('nativeIAPEvent', this.nativeIAPHandler);
    this.userName = localStorage.getItem('screenName');
    this.contact = localStorage.getItem('contact');
    this.route.queryParams.subscribe(params => {
      this.paymentType = params['type'];
      if (this.paymentType === 'channel') {
        this.selectedPlan = {
          channelId: params['channelId'],
          channel: decodeURIComponent(params['channel']),
          subscriptionId: params['subId'],
          durationId: params['durId'],
          cost: params['planAmount'],
          durationName: decodeURIComponent(params['durationName']),
          vidLibId: params['vidLibId'],
          contentType: params['contentType'],
          currency: params['currency'],
          currencySymbol: params['currencySymbol']
        };
      } 
      else if (this.paymentType === 'ppv') {
        this.selectedPlan = {
          vidLibId: params['vidLibId'],
          movie: decodeURIComponent(params['movie']),
          durationId: params['durId'],
          cost: params['planAmount'],
          durationName: decodeURIComponent(params['durationName']),
          currency: params['currency'],
          currencySymbol: params['currencySymbol']
        };
      }
      if (params['transactionId'] && !this.isPaymentHandled) {
        this.isPaymentHandled = true;
        console.log("got transactionid")
        const data = {
          status: 'success',
          subType: this.paymentType,
          vidLibId: this.selectedPlan?.vidLibId,
          message: 'Your Subscription is in progress! Please wait.',
          transactionId: params['transactionId'],
          dateOfSubscription: new Date(),
          dateOfExpiry: new Date(),
          amount: this.selectedPlan?.cost,
          detailsRoute: 'channel',
          channelId: params['channelId'],
          currency: params['currency'],
          currencySymbol: params['currencySymbol']
        };
        console.log("opeining modal")
        this.showPaymentStatus(data);
      }
    });
  }
  // ngOnInit(): void {
    // this.userId = localStorage.getItem('userId');
    // if(this.userId){
    //   this.getUserWallet(this.userId);
    // }
  // }

  ngOnDestroy() {
    window.removeEventListener('nativeIAPEvent', this.nativeIAPHandler);
    window.removeEventListener('purchaseCancelled', this.purchaseCancelledHandler);
  }

  openHistory(){
    window.history.back();
  }

  getUserWallet(userId:string){
    this.walletService.getWalletInfo(`wallet-id-${userId}`).subscribe((result)=>{
      console.log(result)
      this.wallet = result;
    })
  }

  proceedToPayment(){
    const token = localStorage.getItem('token');
    if (this.bridgeService.isIOS()) {
      this.isLoading = true;
      console.log("you are insdie the ios");
      const payload:any = {
        "action": "purchaseProduct",
        "amount": this.selectedPlan?.cost, 
        "subscriptionId": this.selectedPlan?.subscriptionId,
        "durationId": this.selectedPlan?.durationId,
        "currency": this.selectedPlan?.currency || 'INR',
        "channelId": this.selectedPlan?.channelId,
        "token": token
      };
      if (this.paymentType === 'ppv') {
        payload.vidLibId = this.selectedPlan?.vidLibId;
        payload.subscriptionId = '4';
      }
      this.bridgeService.sendIosPaymentDetails(payload);
      return;
    }
    if(this.paymentMode === 'wallet'){
      this.walletPayment();
    }else if(this.paymentMode === 'cashfree'){
      this.initiatePayment();
    }else if(this.paymentMode === 'toqqerpayments'){
      this.toqqerPayments();
    }
  }

  toqqerPayments() {
    this.isLoading = true;
    const requestBody: any = {
      userId: this.userId,
      planAmount: this.selectedPlan?.cost,
      durationId: this.selectedPlan?.durationId,
      subscriptionId: this.selectedPlan?.subscriptionId,
      currency: this.selectedPlan?.currency || 'INR',
      channelId: this.selectedPlan?.channelId,
      redirectUrl: window.location.href
    };
    if (this.paymentType === 'ppv') {
      requestBody.vidLibId = this.selectedPlan?.vidLibId;
      requestBody.subscriptionId = '4';
    }
    this.walletService.getToqqerPayment(requestBody).subscribe({
      next: (result: any) => {
        this.isLoading = false;
        if (!result?.paymentSessionId) {
          this.showWarning('Payment link not received');
          return;
        }
        window.location.href = result.paymentSessionId;
      },
      error: () => {
        this.isLoading = false;
        this.showWarning('Unable to initiate payment');
      }
    });
  }
  

  walletPayment(){
    this.isLoading = true;
    console.log('wallet payment')
    const requestBody: any = {
      userId: this.userId,
      planAmount: this.selectedPlan?.cost,
      currency: 'INR',
      channelId: this.selectedPlan?.channelId,
      contentId: this.selectedPlan?.vidLibId,
      subscriptionId: this.selectedPlan?.subscriptionId,
      durationId: this.selectedPlan?.durationId,
      walletId: `wallet-id-${this.userId}`,
    };
    if (this.paymentType == 'ppv') {
      console.log('inside')
      requestBody.vidLibId = this.selectedPlan?.vidLibId;
      requestBody.subscriptionId = '4'
    }
    console.log(requestBody);
    this.walletService.walletPayment(requestBody).subscribe((result:any)=>{
      console.log(result);
      this.isLoading = false;
      if(result.results){
        const data = {
          'transactionStatus': 'SUCCESS',
          'subType': this.paymentType,
          'vidLibId': this.selectedPlan?.vidLibId,
          'message': result.message,
          'orderId': result.results.transactionId,
          'updatedAt': result.results.dateOfSubscription,
          'dateOfExpiry': result.results.dateOfExpiry,
          'amount': this.selectedPlan?.cost,
          'detailsRoute': 'channel',
          channelId: this.selectedPlan?.channelId,
          'mode': 'wallet'
        }
        this.showPaymentStatus(data);
      }else{
        this.showWarning(result.message);
      }
    },(error)=>{
      this.isLoading = false;
    })
  }

  showWarning(message:any) {
    this.toastrService.showNotification(
      'warning',
      '',
      message,
      5000
    );
  }

  showSuccess(message:any) {
    this.toastrService.showNotification(
      'success',
      '',
      message,
      3000
    );
  }

  async initiatePayment() {
    this.isLoading = true;
    console.log('Cashfree payment initiation started');
    
    const details:any = {
      userId: this.userId,
      planAmount: this.selectedPlan?.cost,
      currency: 'INR',
      channelId: this.selectedPlan?.channelId,
      contentId: this.selectedPlan?.vidLibId,
      subscriptionId: this.selectedPlan?.subscriptionId,
      durationId: this.selectedPlan?.durationId,
    };
    console.log(details);

    if (this.paymentType == 'ppv') {
      console.log('inside')
      details.vidLibId = this.selectedPlan?.vidLibId;
      details.subscriptionId = '4'
    }
    
    this.walletService.subcriptionPayment(details).subscribe({
      next: (response) => {
        this.openCashfreeCheckout(response);
        this.isLoading = false; 
      },
      error: (err) => {
        console.error('Payment initiation failed', err);
        this.isLoading = false; 
        this.showWarning('Something went wrong.Please try after some time');
      },
    });
  }
  
  async openCashfreeCheckout(response: any) {

    if(this.paymentType === 'ppv'){
      this.redirectUrl = `${window.location.href}&transactionId=${response.orderId}`;
    }else if(this.paymentType === 'channel'){
      this.redirectUrl = `${window.location.href}&transactionId=${response.orderId}`
    }

    try {
      let cashfree = await load({ mode: "sandbox" }); 
      const checkoutOptions = {
        paymentSessionId: response.paymentSessionId, 
        appId: "61571b19abad01b50bc60940d17516",
        orderId: response.orderId,
        customerPhone: this.contact || "",
        customerName: this.userName || "",
        customerEmail: 'testuser@example.com',
        redirectTarget: "_self",
        returnUrl: this.redirectUrl
      };
  
      cashfree.checkout(checkoutOptions)
        .then((result: any) => {
          console.log(result)
        })
        .catch((error: any) => {
          console.error('Cashfree checkout error:', error);
        });
    } catch (error) {
      console.error('Cashfree SDK initialization error:', error);
    }
  }
  
  // private verifyPayment(paymentDetails: any) {
  //   this.walletService.verifyPayment(paymentDetails).subscribe({
  //     next: response => console.log("Payment verified and subscription updated"),
  //     error: err => console.error('Payment verification failed', err),
  //   });
  // }

  showPaymentStatus(data: any) {
    const dialogRef = this.dialog.open(PaymentStatusModalComponent, {
      disableClose: true,
      hasBackdrop: true,
      backdropClass: 'black-backdrop',
      panelClass: 'payment-dialog-panel',
      data: data
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === false) {
        this.removeTransactionIdFromUrl();
      }
    });
  }
  
  removeTransactionIdFromUrl() {
    const queryParams = { ...this.route.snapshot.queryParams };
    if (queryParams['transactionId']) {
      delete queryParams['transactionId'];
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams,
        replaceUrl: true,   
      });
    }
  }
}
